import wx from 'weixin-js-sdk'
import { getWxSign } from '@/api/newUserWelfare'

export const common = {
  data() {
    return {}
  },
  methods: {
    wxConfig (buId) {
      let url = location.href.split('#')[0]
      const params = {
        url: url,
        buId: buId
      }
      // 请求WXconfig数据
      getWxSign(params).then(res => {
        const data = res.data
        wx.config({
          debug: true,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ['updateAppMessageShareData'],
          openTagList: ['wx-open-launch-weapp']
        })
      }).catch( (err) => {
        console.log(err)
      })
    }
  }
}